// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { axios } from './axios';

const baseUrl = `${process.env.API_URL}/api/v1`;

// Stateless conversation: the server keeps nothing, so we resend the last
// HISTORY_CAP messages with every request (matches the API's Zod cap).
const HISTORY_CAP = 20;

const useAssistantStore = create(
  immer((set, get) => ({
    isOpen: false,
    // [{ role: 'user'|'assistant', content, sources? }]
    messages: [],
    isLoading: false,
    error: null,

    open: () => set((state) => { state.isOpen = true; }),
    close: () => set((state) => { state.isOpen = false; }),
    reset: () => set((state) => { state.messages = []; state.error = null; state.isLoading = false; }),

    sendMessage: async (orgId, message, page) => {
      const text = String(message || '').trim();
      if (!text || get().isLoading) return;

      set((state) => {
        state.messages.push({ role: 'user', content: text });
        state.isLoading = true;
        state.error = null;
      });

      const history = get()
        .messages.slice(0, -1)
        .slice(-HISTORY_CAP)
        .map((m) => ({ role: m.role, content: m.content }));

      try {
        const { data } = await axios.post(`${baseUrl}/organizations/${orgId}/assistant/chat`, {
          message: text,
          history,
          page,
        });
        if (data?.status === 0) throw new Error(data?.error || 'The assistant could not answer.');
        set((state) => {
          state.messages.push({
            role: 'assistant',
            content: data.result.reply,
            sources: (data.result.sources || []).filter((s) => s.source === 'docs'),
          });
          state.isLoading = false;
        });
      } catch (e) {
        set((state) => {
          state.isLoading = false;
          state.error = e?.response?.data?.error || e?.message || 'Something went wrong. Please try again.';
        });
      }
    },

    // Re-send the last user message after an error.
    retry: async (orgId, page) => {
      const msgs = get().messages;
      let idx = -1;
      for (let i = msgs.length - 1; i >= 0; i--) {
        if (msgs[i].role === 'user') { idx = i; break; }
      }
      if (idx < 0) return;
      const content = msgs[idx].content;
      // Drop the failed user turn so sendMessage re-appends it once.
      set((state) => { state.messages.splice(idx, 1); state.error = null; });
      await get().sendMessage(orgId, content, page);
    },
  })),
);

export default useAssistantStore;
